import HNSColors from "../../../../ui library/HNSColors";

import { formatAdditionalExpenseCurrency } from "./helpers/functions";

export default function OtherLiensBalanceTotalCapsule({ value }) {
  return (
    <div
      className="flex min-h-[50px] items-center justify-between rounded-[8px] px-4 py-2 text-sm font-medium"
      style={{
        backgroundColor: HNSColors.tertiary[900],
        color: HNSColors.primary[500],
      }}
    >
      <span className="font-semibold">Total</span>
      <span>{formatAdditionalExpenseCurrency(value)}</span>
    </div>
  );
}

